import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { faLinkSlash } from '@fortawesome/pro-light-svg-icons/faLinkSlash';
import { TypedMemo } from '../../common/types';
import { useSMLRouter } from '../../../routing/sml/hooks';
import { SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { PageUnavailable } from '../../app/notFound/PageUnavailable';
import { smartLinkUnavailableMessages } from './smartLinkUnavailableMessages';

/**
 * The SmartLink manage and editor pages for a wrong id, a page of another workspace or a deleted
 * page (QA finding brk-2). It sits in the normal app shell and has a way back to the SmartLinks list.
 */
const SmartLinkUnavailableViewComponent: React.FC = () => {
  const intl = useIntl();
  const router = useSMLRouter();
  const goToSmartLinks = useCallback(() => router.replace(SMLRoutes.smartlinks), [router]);

  return (
    <PageUnavailable
      testId="smartlink-unavailable"
      icon={faLinkSlash}
      title={intl.formatMessage(smartLinkUnavailableMessages.title)}
      text={intl.formatMessage(smartLinkUnavailableMessages.text)}
      primary={{ label: intl.formatMessage(smartLinkUnavailableMessages.back), onClick: goToSmartLinks }}
    />
  );
};

export const SmartLinkUnavailableView = TypedMemo(SmartLinkUnavailableViewComponent);
